// extracted by mini-css-extract-plugin
export var accent = "_bx-4";
export var add = "_bx-j";
export var addIcon = "_bx-k";
export var deleteIcon = "_bx-i";
export var disabled = "_bx-9";
export var ellipsis = "_bx-f";
export var error = "_bx-3";
export var form = "_bx-5";
export var hideFocus = "_bx-2";
export var icon = "_bx-7";
export var input = "_bx-e";
export var listItem = "_bx-h";
export var mediumHeight = "_bx-b";
export var noBorder = "_bx-8";
export var noRadius = "_bx-1";
export var shortHeight = "_bx-a";
export var tallHeight = "_bx-c";
export var textInput = "_bx-0";
export var vertical = "_bx-g";
export var veryTallHeight = "_bx-d";
export var widget = "_bx-6";